export const MICRO_LOAN_NOTIFICATIONS_START =
  'MICRO_LOAN_NOTIFICATIONS_START';
export const MICRO_LOAN_NOTIFICATIONS_SUCCESS =
  'MICRO_LOAN_NOTIFICATIONS_SUCCESS';
export const MICRO_LOAN_NOTIFICATIONS_ERROR =
  'MICRO_LOAN_NOTIFICATIONS_ERROR';

export const READ_MICRO_LOAN_NOTIFICATION_START =
  'READ_MICRO_LOAN_NOTIFICATION_START';
export const READ_MICRO_LOAN_NOTIFICATION_SUCCESS =
  'READ_MICRO_LOAN_NOTIFICATION_SUCCESS';
export const READ_MICRO_LOAN_NOTIFICATION_ERROR =
  'READ_MICRO_LOAN_NOTIFICATION_ERROR';

export const READ_ALL_MICRO_LOAN_NOTIFICATIONS_START =
  'READ_ALL_MICRO_LOAN_NOTIFICATIONS_START';
export const READ_ALL_MICRO_LOAN_NOTIFICATIONS_SUCCESS =
  'READ_ALL_MICRO_LOAN_NOTIFICATIONS_SUCCESS';
export const READ_ALL_MICRO_LOAN_NOTIFICATIONS_ERROR =
  'READ_ALL_MICRO_LOAN_NOTIFICATIONS_ERROR';

export const UNREAD_NOTIFICATIONS_COUNT_SUCCESS =
  'UNREAD_NOTIFICATIONS_COUNT_SUCCESS';
